<template>
  <div
    class="relative dib br-pill ba mr2"
    :class="[info === 'Available' ? 'green' : 'test']"
    :style="'border-color:'+ statusColor + '; color:' + statusColor"
    @click="emitClick(info)"
  >
    <div class="flex pv1 pl2 pr1 items-center">
      <div
        class="f6 nowrap"
        v-if="info"
        v-html="info"
      />
      <svg
        v-if="close"
        class="pl2"
        style="padding-right: 0.35rem; transform: scale(1.5)"
        width="10"
        height="10"
        viewBox="0 0 10 10"
        :fill="statusColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 5C0 2.235 2.235 0 5 0C7.765 0 10 2.235 10 5C10 7.765 7.765 10 5 10C2.235 10 0 7.765 0 5ZM5 4.295L6.295 3L7 3.705L5.705 5L7 6.295L6.295 7L5 5.705L3.705 7L3 6.295L4.295 5L3 3.705L3.705 3L5 4.295Z"
          fill="currentColor"
        />
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Pill',
  props: {
    info: {
      type: String,
      default: null
    },
    statusColor: {
      type: String,
      default: null
    },
    close: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      icon: require('@/assets/img/off-close.svg')
    }
  },
  methods: {
    emitClick (info) {
      this.$emit('click', info)
    }
  }
}
</script>
